const initializeTestimonialSwiper = () => {
  const testimonialSection = document.querySelector(".home-section-testimonials");
  if (!testimonialSection) return;

  const swiper = new Swiper(".home-section-testimonials .swiper", {
      direction: "horizontal",
      loop: true,
      autoplay: {
          delay: 10000,
      },
      speed: 800,
      slidesPerView: 1,
      centeredSlides: true,
      spaceBetween: 0,
      breakpoints: {
          450: {
              slidesPerView: 2,
          },
          768: {
              slidesPerView: 3,
              spaceBetween: 16,
          },
      },
      keyboard: {
          enabled: true,
      },
      pagination: {
          el: ".home-section-testimonials .swiper-pagination",
      },
      navigation: {
          nextEl: ".home-section-testimonials .swiper-button-next",
          prevEl: ".home-section-testimonials .swiper-button-prev",
      },
  });

  console.log('testimonial swiper', swiper)

  document.querySelectorAll(".home-section-testimonials .swiper-slide").forEach((slide) => {
    slide.addEventListener("click", () => {
        const { className } = slide;
        if (className.includes("swiper-slide-next")) {
            swiper.slideNext();
        } else if (className.includes("swiper-slide-prev")) {
            swiper.slidePrev();
        }
    });
  });

  setInterval(() => {
      swiper.slideNext();
  }, 5000);
}

const initializeBrandSwiper = () => {
  const brandSection = document.querySelector(".home-section-brands");
  if (!brandSection) return;

  const swiper = new Swiper(".home-section-brands .swiper", {
    direction: "horizontal",
    loop: true,
    autoplay: true,
    slidesPerView: 2,
    centeredSlides: true,
    speed: 1000,
    spaceBetween: 40,
    breakpoints: {
      500: {
        slidesPerView: 3,
      },
      650: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 5,
      },
      1024: {
        slidesPerView: 6,
      },
      1200: {
        slidesPerView: 7,
      },
    },
  });

};

const initializeCategorySwiper = () => {
  const categoriesSection = document.querySelector(".home-section.home-section-categories");
  if (!categoriesSection) return;

  const swiper = new Swiper(".home-section.home-section-categories .categories-swiper", {
    loop: false,
    // autoplay: {
    //   delay: 8000,
    // },
    // speed: 8000,
    slidesPerView: 1.25,
    spaceBetween: 16,
    breakpoints: {
      500: {
        slidesPerView: 2.25,
      },
      768: {
        slidesPerView: 3.25,
      },
      1200: {
        slidesPerView: 4.25,
        spaceBetween: 24,
      },
    },
    navigation: {
      nextEl: ".home-section.home-section-categories .categories-swiper .swiper-button-next",
      prevEl: ".home-section.home-section-categories .categories-swiper .swiper-button-prev",
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
  });
};

const updateDesignServicesForm = () => {
  const form = document.querySelector('.in-home-design-form')
  if (!form) return;

  const smsConsentDiv = form.querySelector(".sms-consent")
  if (smsConsentDiv) {
    const label = smsConsentDiv.querySelector('label[for="sms-consent"]')
    if (label) {
      label.style.display = "none"
    }

    const consentLabel = smsConsentDiv.querySelector('label[for="sms-consent_yes"]')
    if (consentLabel) {
      consentLabel.innerHTML += ' <span class="required"><sup>*</sup></span>';
    }
  }
};

const updateContactUsStoreLink = () => {
  const contactContainer = document.querySelector(
    ".page-contact-us .contactContainer"
  );
  if (!contactContainer) return;

  // Find link with /locations in href
  const storeLink = contactContainer.querySelector('a[href*="/locations"]');
  if (!storeLink) return;

  storeLink.href = "/locations/bacons-furniture-port-charlotte-fl";
  storeLink.innerText = "Store Location and Directions";
};

const triggerUserway = () => {
  const userwayIcon = document.querySelector('#userwayAccessibilityIcon img');
  if (!userwayIcon) return;
  userwayIcon.click();
};

const accessibilityClickHandler = () => {
  const widgetButton = document.querySelector('#accessibilityWidget');
  if(!widgetButton) return;

  widgetButton.addEventListener('click', (e) => {
    e.preventDefault()
    triggerUserway();
  });
  widgetButton.addEventListener('keypress', (e) => {
    e.preventDefault()
    if (e.key === 'Enter') triggerUserway();
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initializeTestimonialSwiper();
  initializeBrandSwiper();
  initializeCategorySwiper();
  updateDesignServicesForm();
  updateContactUsStoreLink();
  accessibilityClickHandler();
});
